import React from 'react';

export default function renderSvg(SvgOrUrl, props = {}) {
  if (!SvgOrUrl) return null;

  // If it's a plain string (url/data-uri), render an <img>
  if (typeof SvgOrUrl === 'string') {
    return <img src={SvgOrUrl} {...props} />;
  }

  // If it's an object with a default export (common with some bundlers)
  if (SvgOrUrl && typeof SvgOrUrl === 'object' && SvgOrUrl.default) {
    const maybe = SvgOrUrl.default;
    if (typeof maybe === 'string') return <img src={maybe} {...props} />;
    if (typeof maybe === 'function') {
      const Comp = maybe;
      return <Comp {...props} />;
    }
  }

  // If it's a React component (function or class)
  if (typeof SvgOrUrl === 'function') {
    const Comp = SvgOrUrl;
    return <Comp {...props} />;
  }

  return null;
}
